const getAgentStatuses = (arr: any) => {
    const acc = {
        emiratesApproved: false,
        licenseApproved: false,
        passportApproved: false,
        emiratesLoaded: false,
        licenseLoaded: false,
        passportLoaded: false,
        passportReject: false,
        emiratesReject: false,
        licenseReject: false,
        emiratesExpire: false,
        passportExpire: false,
        licenseExpire: false,
        emiratesInProgress: false,
        passportInProgress: false,
        licenseInProgress: false
    }

    const resultObj = arr.reduce((acc: any, el: any) => {
        let checkDocumentType = true
        let documentType, refNumber
        let isThereLinks = false
        let category = '' 
        if (el) {
            if (el.hasOwnProperty('attributes')) {
                documentType = el?.attributes?.Type?.[0]?.__component
                refNumber = el?.attributes?.RefID
                category = el?.attributes?.Category
                isThereLinks = (el?.attributes?.LinkFront !== null && el?.attributes?.LinkBack !== null)
            } else {
                documentType = el?.Type?.[0]?.__component
                refNumber = el?.RefID
                isThereLinks = (el?.LinkFront !== null && el?.LinkBack !== null)
                category = el?.Category
            }
            if (!documentType) {
                checkDocumentType = false
            }
        }
        const dateNow = new Date().getTime()
        const expDate = el && el?.hasOwnProperty('attributes') ? new Date(el?.attributes?.ExpiryDate).getTime() : new Date(el?.ExpiryDate).getTime()
        const statuses = el && el?.hasOwnProperty('attributes') ? el?.attributes?.Statuses : el?.Statuses

        // RERA LICENSE STATUSES
        if ((checkDocumentType ? documentType === 'documents.rera-card' : (refNumber?.includes('rera') || category?.includes("RERA Card") )) && statuses?.includes('Approved') && dateNow < expDate) {
            return { ...acc, licenseApproved: true, licenseLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.rera-card' : (refNumber?.includes('rera') || category?.includes("RERA Card") )) && statuses?.includes('Archived') && dateNow < expDate) {
            return { ...acc, licenseApproved: true, licenseLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.rera-card' : (refNumber?.includes('rera') || category?.includes("RERA Card") )) && statuses?.includes('Approved') && dateNow > expDate) {
            return { ...acc, licenseExpire: true, licenseLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.rera-card' : (refNumber?.includes('rera') || category?.includes("RERA Card") )) && statuses?.includes('In-process')) {
            return { ...acc, licenseInProgress: true, licenseLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.rera-card' : (refNumber?.includes('rera') || category?.includes("RERA Card") )) && statuses?.includes('Rejected')) {
            return { ...acc, licenseReject: true, licenseLoaded: true }
           
            // EMIRATES ID STATUSES
        } else if ((checkDocumentType ? documentType === 'documents.emirates-id' : (refNumber?.includes('emirates_id')  || category?.includes('Emirates ID'))) && statuses?.includes('Approved') && dateNow < expDate  && isThereLinks) {
            return { ...acc, emiratesApproved: true, emiratesLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.emirates-id' : (refNumber?.includes('emirates_id')  || category?.includes('Emirates ID'))) && statuses?.includes('Archived') && dateNow < expDate  && isThereLinks) {
            return { ...acc, emiratesApproved: true, emiratesLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.emirates-id' : (refNumber?.includes('emirates_id')  || category?.includes('Emirates ID'))) && statuses?.includes('Approved') && dateNow > expDate && isThereLinks) {
            return { ...acc, emiratesExpire: true, emiratesLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.emirates-id' : (refNumber?.includes('emirates_id')  || category?.includes('Emirates ID'))) && statuses?.includes('In-process') && isThereLinks) {
            return { ...acc, emiratesInProgress: true, emiratesLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.emirates-id' : (refNumber?.includes('emirates_id')  || category?.includes('Emirates ID'))) && statuses?.includes('Rejected') && isThereLinks) {
            return { ...acc, emiratesReject: true, emiratesLoaded: true }

            // PASSPORT STATUSES
        } else if ((checkDocumentType ? documentType === 'documents.passport' : (refNumber?.includes('visa')  || category?.includes('Passport'))) && statuses?.includes('Approved') && dateNow < expDate) {
            return { ...acc, passportApproved: true, passportLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.passport' : (refNumber?.includes('visa') || category?.includes('Passport'))) && statuses?.includes('Archived') && dateNow < expDate) {
            return { ...acc, passportApproved: true, passportLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.passport' : (refNumber?.includes('visa') || category?.includes('Passport'))) && statuses?.includes('Approved') && dateNow > expDate) {
            return { ...acc, passportExpire: true, passportLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.passport' : (refNumber?.includes('visa') || category?.includes('Passport'))) && statuses?.includes('In-process')) {
            return { ...acc, passportInProgress: true, passportLoaded: true }
        } else if ((checkDocumentType ? documentType === 'documents.passport' : (refNumber?.includes('visa') || category?.includes('Passport'))) && statuses?.includes('Rejected')) {
            return { ...acc, passportReject: true, passportLoaded: true }
        } else {
            return acc
        }
    }, acc)

    return resultObj
}

export default getAgentStatuses
